<template>
<w-sliding-popup ref="slidingPopup" type="setting" title="사용자 정의 OID 그룹 저장" :default-content="false" @close="closePopup">
  <div slot="content" class="body-content-no-scroll" style="height:100%;">
    <div class="mr-r20" style="float: left; height:100%; width: 350px;">
      <w-common-obj-list ref="commonObjList" type="physical" selected-managetype-id="NMS" :show-interface-column="false" />
    </div>
    <div style="float: right; width: calc(100% - 370px);">
      <div class="title-h3 title-bar">선택한 사용자 정의 OID 목록</div>
      <el-table-wrapper style="height: calc(100% - 41px);" :fit-height="true" :data="selectGroupList" :columns="userDefineColumns" :column-default="columnDefault" :pagination="false" :show-custom-header="false">
      </el-table-wrapper>
    </div>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="saveUserOIdGroup">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import { isEmpty, forEach, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WCommonObjList from '@/components/table/CommonObjList';

export default {
  name: 'WGroupSaveUserDefinePopup',
  components: {
    WCommonObjList,
  },
  props: {
    selectGroupList: Array,
  },
  data() {
    return {
      searchKeyword: '',
      columnDefault,
      userDefineColumns: [
        {
          prop: 'rscName',
          label: '사용자정의 자원 이름',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'rscSnmpOid',
          label: 'OID',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  methods: {
    closePopup() {
      this.$refs.commonObjList.initData();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    /**
     * [saveUserOIdGroup 물리 트리에서 선택한 장비에 사용자 정의 OID를 저장한다.]
     * @author yelim
     */
    saveUserOIdGroup() {
      const objIdArr = this.$refs.commonObjList.getSelectedObjList(true);
      if (isEmpty(objIdArr)) {
        this.$message(msgUtil.getRequireMsgData('선택', '장비'));
        return;
      }
      const params = cloneDeep(this.selectGroupList);
      forEach(params, (data) => {
        data.objIds = objIdArr;
      });
      const target = '사용자 정의 OID';
      const action = msgUtil.action.SAVE;
      NetdeviceSettingAPI.saveUserdefineGroupApply(params)
        .then((result) => {
          if (result.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.closePopup();
            this.$emit('reload-data');
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/UserDefineOidSettings/popup/GroupSaveUserDefinePopup.vue